import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Contact";
import { VisionHero } from "@/components/vision/VisionHero";
import { CoreVision } from "@/components/vision/CoreVision";
import { IdeaCascade } from "@/components/vision/IdeaCascade";
import { Vision2047 } from "@/components/vision/Vision2047";
import { EcosystemNetwork } from "@/components/vision/EcosystemNetwork";
import { EmploymentVision } from "@/components/vision/EmploymentVision";
import { NextGeneration } from "@/components/vision/NextGeneration";
import { LocalGlobal } from "@/components/vision/LocalGlobal";
import { TechHuman } from "@/components/vision/TechHuman";
import { FinalVision } from "@/components/vision/FinalVision";

export default function Vision() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));
  }, []);

  return (
    <div data-testid="vision-page" className="relative w-full max-w-[100vw] overflow-x-clip text-slate-100">
      <Header />
      <main>
        <VisionHero />
        <CoreVision />
        <IdeaCascade />
        <Vision2047 />
        <EcosystemNetwork />
        <EmploymentVision />
        <NextGeneration />
        <LocalGlobal />
        <TechHuman />
        <FinalVision />
      </main>
      <Footer settings={settings} />
    </div>
  );
}
